import { useMemo } from 'react'
import { useGetServicetypesServiceTypeId } from '../../../api/generated/service-type/service-type'
import { NON_IN_PERSON_METHOD_OPTIONS, VIDEO_ONLY_METHOD_OPTIONS } from '../components/visit-information/VisitMethods'

/**
 * Determines the available visit methods based on:
 * 1. The visit type's IsPhoneVisitCommunicationTypeAllowed (from service type API)
 * 2. The state's IsPhoneVisitCommunicationTypeAllowed (from Redux statesSettings)
 *
 * Both must be true for Phone to be available. Otherwise only Video is available.
 *
 * @param {Object} selectedVisit - The currently selected visit type object
 * @param {string} selectedStateString - The selected state string (e.g., "California CA")
 * @param {Array} settingsPerState - Redux state.management.statesSettings.SettingsPerState
 * @returns {{ methods: Array, isMethodsLoading: boolean }}
 */
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const useVisitMethods = (selectedVisit, selectedStateString, settingsPerState) => {
  const serviceTypeId = selectedVisit?.ServiceTypeId || ''

  const { data: serviceTypeData, isLoading: isServiceTypeLoading } = useGetServicetypesServiceTypeId(serviceTypeId, {
    query: { enabled: Boolean(serviceTypeId) },
  })

  const selectedStateCode = selectedStateString ? selectedStateString.split(' ').pop()?.toUpperCase() : null

  const methods = useMemo(() => {
    if (!serviceTypeData || !selectedStateCode || !settingsPerState?.length) {
      return NON_IN_PERSON_METHOD_OPTIONS
    }

    const visitTypeId = selectedVisit?.VisitTypes?.VisitTypeId || selectedVisit?.VisitTypeId
    const visitTypeFromApi = serviceTypeData.VisitTypes?.find((vt) => vt.VisitTypeId === visitTypeId)

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const stateSetting = settingsPerState.find((s) => s.StateCode?.toUpperCase() === selectedStateCode)

    const visitTypePhoneAllowed = visitTypeFromApi?.IsPhoneVisitCommunicationTypeAllowed ?? true
    const statePhoneAllowed = stateSetting?.IsPhoneVisitCommunicationTypeAllowed ?? true

    if (visitTypePhoneAllowed && statePhoneAllowed) {
      return NON_IN_PERSON_METHOD_OPTIONS
    }

    return VIDEO_ONLY_METHOD_OPTIONS
  }, [serviceTypeData, selectedStateCode, settingsPerState, selectedVisit])

  const isMethodsLoading = !!serviceTypeId && !!selectedStateCode && isServiceTypeLoading

  return { methods, isMethodsLoading }
}
